import {Quote} from "../../api/models";
import React, {CSSProperties, useRef, useState} from "react";
import {Button, Popover} from "antd";
import TextArea from "antd/es/input/TextArea";

const QuoteNotesInput = (props:{
    quote:Quote | undefined
    readOnly?: boolean
    onChange?: (n: string | undefined) => void
    txtStyle?: CSSProperties
    btnStyle?: CSSProperties
}) => {

    const [isOpen, setIsOpen] = useState<boolean>(false);
    const inputRef = useRef<any>(null);
    const txtStyle = {
        borderBottom: "1px solid black",
        ...props.txtStyle,
    };
    const [notes, setNotes] = useState<string>();

    const handleOpen = () => {
        setNotes( props.quote?.notes );
        setIsOpen(true);
    }
    const handleBlur = () => {

        setIsOpen(false);

        props.onChange?.( notes );
    }

    const btnTitle = props.quote?.notes && props.quote.notes.trim().length > 0 ? props.quote?.notes : "None";
    return <Popover
        trigger={"click"}
        afterOpenChange={(open) => {
            if( open ) {
                inputRef.current?.focus();
            }
        }}
        open={isOpen}
        content={<TextArea
            ref={inputRef}
            style={{width: "40rem"}}
            value={notes}
            placeholder="Type notes."
            onChange={(e) => setNotes(e.target.value)}
            onBlur={handleBlur}
            rows={6}
        /> }
        arrow={false}
    >
        {props.readOnly ? btnTitle 
            : <Button className="ghostBmButton" type="text" onClick={handleOpen}
                          title={btnTitle}
                          style={{
                              ...props.btnStyle,
                              margin: 0,
                              padding: 0,
                              display: "unset",
                              textAlign: "unset"
                          }} >
                    {props.quote?.notes
                        ? <div style={{whiteSpace: "pre-wrap", textAlign:"left", display: "contents"}} >
                            {btnTitle}
                        </div>
                        : <span style={txtStyle}>{btnTitle}</span> }
                </Button>}
    </Popover>;
}

export default QuoteNotesInput;
